import React from 'react';
import NavbarTop from './NavbarTop';

function Header() {
  return (
    <NavbarTop />
  )
}

export default Header